import React from 'react';
import { termsDataMonths } from '../../enums/termsData'
import replaceDotWithComma from '../../../../helpers/utils/replaceDotWithComma';

export default function template(context) {
  const calc = context.calc,
    model = calc.state.model;
  return (
    <React.Fragment>
      <div className="loan-conditions-table">
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN')}</div>
          <div className="condition-text">{model.getCreditSum().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_FORM_TITLE')}</div>
          <div className="condition-text">{model.getCreditTerm()} {calc.l10n(termsDataMonths[model.getCreditTerm()].text)}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW')}</div>
          <div className="condition-text">{model.getRequiredPayment().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_OVERPAYMENT_AEXPRESS')}</div>
          <div className="condition-text">{model.getOverpayment().toLocaleString() <= '0' ? '0' : model.getOverpayment().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
        </div>
      </div>
      <div className="loan-conditions-lines">
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_TOTAL_COST')}</div>
          <div className="condition-text">{model.getCreditCost().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
        </div>
        <div className="loan-conditions-item">
          <div className="condition-title">{calc.l10n('CALCULATOR_REAL_INTEREST_RATE_NEW_DESIGN')}</div>
          <div className="condition-text">{replaceDotWithComma(model.getShownRealRate())}{calc.l10n('CALCULATOR_CREDIT_PERCENT')}</div>
        </div>
        <div className="disclaimer">{calc.l10n('CALCULATOR_DISCLAIMER')}</div>
      </div>
    </React.Fragment>
  );
}
